import { render, staticRenderFns } from "./comment-field.vue?vue&type=template&id=ac279f3e"
import script from "./comment-field.vue?vue&type=script&lang=js"
export * from "./comment-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports